import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Ateliers from './components/ateliers/ateliers';
import Creche from './components/ateliers/details/creche/creche';
import Senior from './components/ateliers/details/senior/senior';
import Événements from './components/événements/événements';
import Mariage from './components/événements/details/mariage/mariage';
import Deuil from './components/bouquets/obseques/obseques';
import Fleuristerie from './components/bouquets/fleuristerie';
import Plantes from './components/plantes/plantes';
import QuiSuisJe from './components/quisuisje/quisuisje';
import Contact  from './components/contact/contact';
import './App.css';
import SmoothScroll from "smooth-scroll";
import MentionsLegales from "./components/footer/mentions_legales";
import Paysagiste from "./components/paysagiste/paysagiste";
import APropos from "./components/apropos/octobrerose/octobrerose";
import ScrollToTop from "./ScrollToTop";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <div>
          <BrowserRouter>
          <ScrollToTop />
      <Routes>
      <Route path="/" exact element={<Home />} />
      <Route path="/exclusivité_du_moment" element={<APropos />} />
            <Route path="/ateliers" element={<Ateliers />} />
                        <Route path="/ateliers_crèche" element={<Creche />} />
            <Route path="/ateliers_senior" element={<Senior />} />
      <Route path="/fleuristerie_artisanale/bouquets" element={<Fleuristerie />} />
      <Route path="/plantes" element={<Plantes />} />
            <Route path="/événements/autre" element={<Événements />} />
            <Route path="/événements/mariage" element={<Mariage />} />
            <Route path="/fleuristerie_artisanale/deuil" element={<Deuil />} />

      
      <Route path="/qui_suis_je" element={<QuiSuisJe />} />
            <Route path="/paysagiste" element={<Paysagiste />} />

      <Route path="/contact" element={<Contact />} />
      <Route path="/mentions_legales" element={<MentionsLegales />} />

      </Routes>
      </BrowserRouter>


      </div>
  );
}

export default App;
